import type {paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

type UpdateIdentificationInfoOperation = paths['/executor_web/identification/info']['patch'];

export type UpdateIdentificationInfoRequest = NonNullable<
	NonNullable<UpdateIdentificationInfoOperation['requestBody']>['content']['application/json']
>;
export type UpdateIdentificationInfoResponse =
	UpdateIdentificationInfoOperation['responses'][200]['content']['application/json'];

/** PATCH `/executor_web/identification/info` — см. `paths['/executor_web/identification/info']` в auth swagger */
export function updateIdentificationInfo(request: UpdateIdentificationInfoRequest, signal?: AbortSignal) {
	return axiosInstance.patch<UpdateIdentificationInfoResponse>('identification/info', request, {signal});
}
